import { gql } from '@apollo/client';

export const CHECKLIST_FRAGMENT = gql`
  fragment ChecklistFields on Checklist {
    id
    title
    description
    isActive
    items {
      id
      description
      type
      isRequired
      sortOrder
      categoryId
      category {
        id
        title
      }
    }
    createdAt
    updatedAt
  }
`;

export const GET_CHECKLISTS = gql`
  query Checklists {
    checklists {
      id
      title
      description
      isActive
      items {
        id
        title
        description
        type
        isRequired
        sortOrder
        categoryId
        category {
          id
          title
        }
      }
    }
  }
`;

export const GET_CHECKLIST = gql`
  query GetChecklist($id: ID!) {
    checklist(id: $id) {
      ...ChecklistFields
    }
  }
  ${CHECKLIST_FRAGMENT}
`;

export const CREATE_CHECKLIST = gql`
  mutation CreateChecklist($input: CreateChecklistInput!) {
    createChecklist(input: $input) {
      id
      title
      description
      isActive
      items {
        id
        title
        description
        type
        isRequired
        sortOrder
        categoryId
        category {
          id
          title
        }
      }
    }
  }
`;

export const UPDATE_CHECKLIST = gql`
  mutation UpdateChecklist($input: UpdateChecklistInput!) {
    updateChecklist(input: $input) {
      id
      title
      description
      isActive
      items {
        id
        title
        description
        type
        isRequired
        sortOrder
        categoryId
        category {
          id
          title
        }
      }
    }
  }
`;

export const DELETE_CHECKLIST = gql`
  mutation DeleteChecklist($id: ID!) {
    deleteChecklist(id: $id)
  }
`;

export const GET_CHECKLIST_CATEGORIES = gql`
  query ChecklistCategories {
    checklistCategories {
      id
      title
      description
      color
      isActive
      sortOrder
      items {
        id
        title
        description
        type
        isRequired
        sortOrder
      }
    }
  }
`;

export const CREATE_CHECKLIST_CATEGORY = gql`
  mutation CreateChecklistCategory(
    $title: String!
    $description: String!
    $color: String!
    $sortOrder: Float
  ) {
    createChecklistCategory(
      title: $title
      description: $description
      color: $color
      sortOrder: $sortOrder
    ) {
      id
      title
      description
      color
      isActive
      sortOrder
    }
  }
`;

export const UPDATE_CHECKLIST_CATEGORY = gql`
  mutation UpdateChecklistCategory(
    $id: ID!
    $title: String
    $description: String
    $color: String
    $sortOrder: Float
  ) {
    updateChecklistCategory(
      id: $id
      title: $title
      description: $description
      color: $color
      sortOrder: $sortOrder
    ) {
      id
      title
      description
      color
      isActive
      sortOrder
    }
  }
`;

export const TOGGLE_CHECKLIST_CATEGORY_STATUS = gql`
  mutation ToggleChecklistCategoryStatus($id: ID!) {
    toggleChecklistCategoryStatus(id: $id) {
      id
      isActive
    }
  }
`;

export const UPDATE_CHECKLIST_CATEGORY_ORDER = gql`
  mutation UpdateChecklistCategoryOrder($items: [[String!]!]!) {
    updateChecklistCategoryOrder(items: $items)
  }
`;

export const CREATE_CHECKLIST_ITEM = gql`
  mutation CreateChecklistItem(
    $title: String!
    $description: String!
    $type: ChecklistItemType!
    $isRequired: Boolean!
    $categoryId: ID!
    $sortOrder: Float!
  ) {
    createChecklistItem(
      title: $title
      description: $description
      type: $type
      isRequired: $isRequired
      categoryId: $categoryId
      sortOrder: $sortOrder
    ) {
      id
      title
      description
      type
      isRequired
      sortOrder
      categoryId
      category {
        id
        title
      }
    }
  }
`;

export const UPDATE_CHECKLIST_ITEM = gql`
  mutation UpdateChecklistItem(
    $id: ID!
    $description: String
    $type: ChecklistItemType
    $isRequired: Boolean
    $sortOrder: Float
  ) {
    updateChecklistItem(
      id: $id
      description: $description
      type: $type
      isRequired: $isRequired
      sortOrder: $sortOrder
    ) {
      id
      title
      description
      type
      isRequired
      sortOrder
      categoryId
      category {
        id
        title
      }
    }
  }
`;

export const DELETE_CHECKLIST_ITEM = gql`
  mutation DeleteChecklistItem($id: ID!) {
    deleteChecklistItem(id: $id)
  }
`;

export const UPDATE_CHECKLIST_ITEM_ORDER = gql`
  mutation UpdateChecklistItemOrder($items: [[String!]!]!) {
    updateChecklistItemOrder(items: $items)
  }
`;

export const DELETE_CHECKLIST_CATEGORY = gql`
  mutation DeleteChecklistCategory($id: ID!) {
    deleteChecklistCategory(id: $id)
  }
`; 